import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './components/AuthProvider';
import { LoadingProvider, setLoadingInstance, useLoading } from "./components/LoadingProvider";
import { motion } from "framer-motion";
import { FaCarSide } from "react-icons/fa";



const GlobalSpinner = () => {
  const { loading } = useLoading();
  if (!loading) return null;
  

  return (
    <motion.div 
      className="car-loader-overlay"
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }} 
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <motion.div 
        className="car-icon"
        animate={{ scale: [1, 1.2, 1], opacity: [0.7, 1, 0.7] }}
        transition={{ repeat: Infinity, duration: 1 }}
      >
        <FaCarSide size={60} color="white" />
      </motion.div>
      <div className="loading-text">Please wait...</div>
    </motion.div>
  );
};

const RootComponent = () => {
  const loadingContext = useLoading();
  setLoadingInstance(loadingContext);

  return <App />;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
  <AuthProvider>
    <LoadingProvider>
      <GlobalSpinner />
      <RootComponent />
    </LoadingProvider>
  </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
